export const getDetailsRoute = (
  installationId = ':installationId',
  storageId = ':storageId',
  powerMeterIndex: string | number = ':powerMeterIndex',
  url?: string
): string => {
  if (url) {
    return `${url}/properties/power-meter/${powerMeterIndex}`
  }

  return `/installation/${installationId}/${storageId}/properties/power-meter/${powerMeterIndex}`
}

export const getFarmDetailsRoute = (
  installationId = ':installationId',
  storageId = ':storageId',
  childStorageId: string | number = ':childStorageId',
  powerMeterIndex: string | number = ':powerMeterIndex',
  url?: string
): string => {
  if (url) {
    return `${url}/properties/power-meter`
  }

  return `/installation/${installationId}/${storageId}/properties/power-meter/${childStorageId}/${powerMeterIndex}`
}

export const getDetailsDispatchRoute = (installationId: string | number = ':installationId', storageId = ':storageId', url?: string): string => {
  if (url) {
    return `${url}/properties/power-meter`
  }
  return `/installation/${installationId}/${storageId}/properties/power-meter`
}
